export const getLocationDisplayName = location => String(location?.name || '')
  .replace(/\s*-\s*default$/i, '')
  .replace(/^default$/i, '')
  .trim() || location?.airportCode || location?.airport || 'Location';